import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { Router } from '@angular/router';
import { ThemeService } from '../../features/theme/theme.service';
import { ToastrService } from 'ngx-toastr';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialog } from '../../shared/components/confirm-dialog/confirm-dialog';
import { PermissionDirective } from '../../shared/components/directives/permissions.directives';
import { debounceTime, distinctUntilChanged, Subject } from 'rxjs';
import { NoDataComponent } from '../../shared/components/no-data/nodata.component';
import { ContentLoaderComponent } from '../../shared/components/content-loader-component/contentLoader.component';

@Component({
  selector: 'app-themes',
  imports: [
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    MatSelectModule,
    CommonModule,
    PermissionDirective,
    NoDataComponent,
    ContentLoaderComponent,
  ],
  templateUrl: './themes.component.html',
  styleUrl: './themes.component.scss',
})
export class ThemesComponent {
  themesArray: { id: number; themeName: string }[] = [];
  public langCode: string = '';
  noData = false;
  loading = false;

  searchTerm: string = '';
  private searchSubject = new Subject<string>();

  readonly dialog = inject(MatDialog);
  constructor(
    private router: Router,
    private themeService: ThemeService,
    private toastr: ToastrService
  ) {}

  ngOnInit() {
    this.getAllThemes(this.langCode);
    this.searchSubject
      .pipe(debounceTime(600), distinctUntilChanged())
      .subscribe((searchTerm) => {
        this.getAllThemes(this.langCode, searchTerm);
      });
  }

  createNewTheme() {
    this.router.navigate(['themes/new']);
  }

  onEditTheme(id: any) {
    this.router.navigate([`themes/edit/${id}`]);
  }

  onSearch(event: Event) {
    const input = event.target as HTMLInputElement;
    const searchTerm = input.value;
    this.searchSubject.next(searchTerm);
  }

  onDeleteTheme(id: any) {
    const dialogRef = this.dialog.open(ConfirmDialog);
    dialogRef.afterClosed().subscribe((result) => {
      if (result === true) {
        this.deleteTheme(id);
      }
    });
  }

  deleteTheme(id: any): void {
    this.themeService.removeTheme(id).subscribe({
      next: (res) => {
        this.toastr.success(res.message);
        this.getAllThemes(this.langCode);
      },
      error: (err) => {
        console.log(err);
      },
    });
  }

  getAllThemes(lang: string, search = ''): void {
    this.loading = true;
    this.themeService.getAllThemes(lang, search).subscribe({
      next: (res) => {
        const themeList = res?.data || [];
        if (themeList.length === 0) {
          this.noData = true;
        } else {
          this.noData = false;
        }
        this.themesArray = themeList
          .map((theme: any) => {
            const translations = theme.themeTranslation || [];
            if (translations.length === 0) {
              return null;
            }
            const lang1Translation = translations.find(
              (t: any) => t.langId === 1
            );
            return {
              id: theme.id,
              themeName: lang1Translation
                ? lang1Translation.themeName
                : translations[0].themeName,
            };
          })
          .filter((theme: any) => theme !== null);
        this.loading = false;
      },
      error: (err) => {
        this.loading = false;
        this.noData = true;
        console.log(err);
      },
    });
  }
}
